<div class="tags-container">
  <div class="content-center">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="spinner"></div>
      <p>Loading tags...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorMessage && !isLoading" class="error-state">
      <div class="error-icon">⚠️</div>
      <p>{{ errorMessage }}</p>
      <button class="btn retry-btn" (click)="retry()">Retry</button>
    </div>

    <!-- Tags Content -->
    <div *ngIf="!isLoading && !errorMessage">
      <!-- Card -->
      <div class="table-card">
        <!-- Table header -->
        <div class="table-head">
          <div class="th th-tag">Tags</div>
          <div class="th th-delete">Delete</div>
        </div>

        <!-- Table body -->
        <div class="table-body">
          <!-- Empty State -->
          <div *ngIf="tagList.length === 0 && !showAddInline" class="empty-state">
            <p>No tags found. Add your first tag!</p>
          </div>

          <!-- Tags List -->
          <div class="table-row" *ngFor="let tag of tagList">
            <div class="td td-tag">{{ tag.name }}</div>
            <div class="td td-delete">
              <a class="delete-link" (click)="requestDelete(tag.id, tag.name)">Delete</a>
            </div>
          </div>

          <!-- Inline Add Row -->
          <div class="add-row" *ngIf="showAddInline">
            <div class="add-input">
              <wm-common-textfield
                #addInput
                [data]="{ placeholder: 'Enter tag name' }"
                [(ngModel)]="newTag"
                name="newTag"
                (keyup.enter)="saveNewTag()"
              ></wm-common-textfield>
            </div>

            <div class="add-controls">
              <button type="button" class="btn cancel" (click)="cancelAdd()">CANCEL</button>
              <button type="button" class="btn save" (click)="saveNewTag()" [disabled]="!newTag.trim()">SAVE</button>
            </div>
          </div>

          <!-- Add link row -->
          <div class="add-link-row" *ngIf="!showAddInline">
            <a class="add-tag" (click)="openAddTag()">+ Add Tag</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation Modal -->
  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="confirmDelete()"
    (onNoClick)="cancelDelete()"
    [isApplicantMobileview]="true"
  ></wm-common-confirmation-modal>
</div>